module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/heart_01.png?f4c568afb7679b117abb6fae13bd93a3";